import { combineReducers } from 'redux';
import pageLayout from './page-layout';

export default combineReducers({
  pageLayout
});
